export default "__VITE_ASSET__6ustZkeC__"